import { render, staticRenderFns } from "./police-record-form.vue?vue&type=template&id=a0a7f300&scoped=true"
import script from "./police-record-form.vue?vue&type=script&lang=js"
export * from "./police-record-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a7f300",
  null
  
)

export default component.exports